import { type ResourcesConfig } from "aws-amplify";

const userPoolId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID;
const userPoolClientId = process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID;

// F1 (plan-eng-review 2026-04-30): production must have Cognito env
// vars set. Without this guard, a production build that's missing the
// env vars would render `isCognitoConfigured = false`, triggering the
// dev-token branches in AuthContext (`DEV_AUTH_TOKEN`) and login/page
// (`DEV_ROLES`) — which would auto-authenticate every visitor as the
// test analyst. Backend currently rejects test tokens in non-mock
// mode (`auth.ts:84-89`), so today this is belt-only. This is the
// braces: fail the build (or the runtime import) hard.
//
// Local dev (NODE_ENV=development) and test runners (NODE_ENV=test)
// are unaffected — they're allowed to run without Cognito.
if (process.env.NODE_ENV === "production" && (!userPoolId || !userPoolClientId)) {
  throw new Error(
    "Production build requires NEXT_PUBLIC_COGNITO_USER_POOL_ID and " +
      "NEXT_PUBLIC_COGNITO_CLIENT_ID. Without them the frontend would " +
      "fall back to dev test tokens — see lib/amplify-config.ts F1.",
  );
}

export const isCognitoConfigured = !!userPoolId && !!userPoolClientId;

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: userPoolId || "placeholder",
      userPoolClientId: userPoolClientId || "placeholder",
    },
  },
};
